<ng-container
  *cignaWaitToLoad="
    adjustments;
    let adjustmentsData;
    errorState: error;
    loadingState: loading
  "
>
  <h2 *ngIf="!shouldHideHeading" class="cg-margin-bottom-md">
    Reconsideration History
  </h2>

  <table
    *ngIf="adjustmentsData?.length; else noAdjustments"
    class="cg-datatable"
    data-test-id="claim-adjustment-history"
  >
    <thead>
      <tr>
        <th
          data-test-id="reference-number-header"
          class="cg-datatable__header nosort-header-container"
          style="width: 200px"
        >
          {{
            (isPrecert
              ? 'shared.reconsiderationHistory.headers.appealNumber'
              : 'shared.reconsiderationHistory.headers.referenceNumber'
            ) | translate
          }}
        </th>
        <th
          data-test-id="recon-type-header"
          class="cg-datatable__header nosort-header-container"
          *ngIf="!isPrecert"
        >
          Type
        </th>
        <th
          data-test-id="modified-by-header"
          class="cg-datatable__header nosort-header-container"
        >
          {{ 'shared.reconsiderationHistory.headers.submittedBy' | translate }}
        </th>
        <th
          data-test-id="modified-date-header"
          class="cg-datatable__header nosort-header-container"
        >
          {{
            'shared.reconsiderationHistory.headers.submissionDate' | translate
          }}
        </th>
        <th
          data-test-id="status-header"
          class="cg-datatable__header nosort-header-container"
          style="width: 300px"
        >
          {{ 'shared.reconsiderationHistory.headers.status' | translate }}
        </th>
        <th
          data-test-id="decision-notes-header"
          class="cg-datatable__header nosort-header-container"
          style="width: 210px"
        >
          {{
            'shared.reconsiderationHistory.headers.decisionNotes' | translate
          }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let adjustment of adjustmentsData; index as i"
        data-test-id="adjustment"
      >
        <td
          class="cg-datatable__cell ref-number"
          data-test-id="reference-number"
        >
          <button
            *ngIf="adjustment.status === 'DRAFT'"
            aria-label="Remove reconsideration"
            data-test-id="remove-reconsideration"
            cignaButton="link no-underline small"
            class="remove"
            (click)="remove(adjustment.id, adjustment.reconsiderationType)"
            [disabled]="!hasReconsiderationAccess || isImpersonator"
          >
            <cigna-icon type="close-thin"></cigna-icon>
          </button>

          <button
            style="padding: 0"
            cignaButton="link"
            [attr.data-test-id]="'lnk-' + adjustment.extRefNum"
            (click)="accessHistory(i)"
            [disabled]="!hasReconsiderationAccess && !adjustment.extRefNum"
            [cignaTrackClicks]="
              adjustment.extRefNum && appealNumberClickTrack
                ? appealNumberClickTrack
                : [
                    'trackEventOther',
                    adjustment.extRefNum
                      ? isPrecert
                        ? 'Appeal Number Click'
                        : 'Reconsideration Number Click'
                      : 'Open Draft',
                    'ac-rec014'
                  ]
            "
          >
            {{
              adjustment.extRefNum
                ? '#' + adjustment.extRefNum
                : ('shared.reconsiderationHistory.draftReferenceNumberFallback'
                  | translate)
            }}
          </button>
        </td>

        <td
          class="cg-datatable__cell"
          *ngIf="!isPrecert"
          data-test-id="reconsideration-type"
        >
          {{ getDisplayReconsiderationType(adjustment) | titlecase }}
        </td>
        <td class="cg-datatable__cell" data-test-id="modified-by">
          {{
            (
              (adjustment.submittedBy?.firstName || '') +
              ' ' +
              (adjustment.submittedBy?.lastName || '')
            ).trim() || '--'
          }}
        </td>
        <td class="cg-datatable__cell" data-test-id="modified-date">
          <ng-container *ngIf="adjustment.submittedDate; else noSubmittedDate">
            <ng-container>{{
              adjustment.submittedDate | date : 'M/d/yyyy'
            }}</ng-container>
            at
            <ng-container>{{
              adjustment.submittedDate | date : 'h:mm a'
            }}</ng-container>
          </ng-container>
          <ng-template #noSubmittedDate>--</ng-template>
        </td>

        <td class="cg-datatable__cell" data-test-id="lbl-status-cell">
          <ng-container
            *ngIf="
              adjustment.status === 'DRAFT' &&
                adjustment.expirationTime !== null;
              else status
            "
          >
            <div
              *ngIf="
                getDraftDaysRemaining(adjustment);
                let daysRemaining;
                else: lastDay
              "
              data-test-id="daysRemaining"
            >
              {{ daysRemaining }}
              {{ 'shared.reconsiderationHistory.daysRemaining' | translate }}
            </div>
            <ng-template #lastDay>
              <div data-test-id="lastDayRemaining">
                {{
                  'shared.reconsiderationHistory.lastDayRemaining' | translate
                }}
              </div>
            </ng-template>
          </ng-container>

          <ng-template #status>
            <div data-test-id="status" style="display: flex">
              <ng-container
                *ngIf="adjustment.isDowncodingAdjustment; else normalStatusHelp"
              >
                <ng-leaf-badge
                  variant="subtle"
                  status="neutral"
                  [text]="
                    knownDowncodeStatuses.includes(adjustment.status)
                      ? adjustmentDisplayStatusNEW[adjustment.status]
                      : 'Not Available'
                  "
                ></ng-leaf-badge>

                <ng-container
                  *ngIf="
                    adjustment.status === 'DOWNCODING_UNDER_REVIEW' ||
                    adjustment.status === 'IN_PROCESS'
                  "
                >
                  <cigna-popover
                    [content]="adjustmentStatus"
                    placement="top"
                    underlineStyle="no-underline"
                    [areaLabelText]=""
                    ><ng-container
                      *ngIf="infoIconClickTrack; else downcodeStatusHelpIcon"
                    >
                      <span
                        class="cg-margin-left-sm"
                        [cignaTrackClicks]="infoIconClickTrack"
                      >
                        <mat-icon
                          svgIcon="leaf-system-regular-help"
                          class="cg-icon-xs"
                        ></mat-icon>
                      </span>
                    </ng-container>
                    <ng-template #downcodeStatusHelpIcon>
                      <mat-icon
                        svgIcon="leaf-system-regular-help"
                        class="cg-icon-xs cg-margin-left-sm"
                      ></mat-icon> </ng-template
                  ></cigna-popover>
                  <ng-template
                    data-test-id="cigna-popover-text"
                    #adjustmentStatus
                  >
                    <ng-container [ngSwitch]="adjustment.status">
                      <div *ngSwitchCase="'IN_PROCESS'">
                        {{
                          'shared.reconsiderationHistory.statusHelpDialog.help20_definition13'
                            | translate
                        }}
                      </div>

                      <div *ngSwitchCase="'DOWNCODING_UNDER_REVIEW'">
                        {{
                          'shared.reconsiderationHistory.statusHelpDialog.help20_definition13'
                            | translate
                        }}
                      </div>

                      <div *ngSwitchCase="'RECEIVED'">
                        {{
                          'shared.reconsiderationHistory.statusHelpDialog.help20_definition13'
                            | translate
                        }}
                      </div>

                      <div *ngSwitchDefault></div>
                    </ng-container>
                  </ng-template>
                </ng-container>
              </ng-container>
              <ng-template #normalStatusHelp>
                <ng-leaf-badge
                  variant="subtle"
                  status="neutral"
                  [text]="adjustmentDisplayStatusNEW[adjustment.status]"
                ></ng-leaf-badge>
                <cigna-popover
                  [content]="adjustmentStatus"
                  placement="top"
                  underlineStyle="no-underline"
                  [areaLabelText]=""
                  ><ng-container
                    *ngIf="infoIconClickTrack; else normalStatusHelpIcon"
                  >
                    <span
                      class="cg-margin-left-sm"
                      [cignaTrackClicks]="infoIconClickTrack"
                    >
                      <mat-icon
                        svgIcon="leaf-system-regular-help"
                        class="cg-icon-xs"
                      ></mat-icon>
                    </span>
                  </ng-container>
                  <ng-template #normalStatusHelpIcon>
                    <mat-icon
                      svgIcon="leaf-system-regular-help"
                      class="cg-icon-xs cg-margin-left-sm"
                    ></mat-icon> </ng-template
                ></cigna-popover>
                <ng-template
                  data-test-id="cigna-popover-text"
                  #adjustmentStatus
                >
                  <ng-container [ngSwitch]="adjustment.status">
                    <div *ngSwitchCase="'ADJUSTED'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition5'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'SCANNER_PENDING'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition1'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'SCANNER_FAILED'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition2'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'RECEIVED'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition3'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'IN_PROCESS'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition4'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'UPHELD_SUCCESS'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition6'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'UPHELD_INSUFFICIENT_INFO'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition7'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'PENDED'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition8'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'REROUTED_TO_CORR'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition12'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchCase="'DOWNCODING_UNDER_REVIEW'">
                      {{
                        'shared.reconsiderationHistory.statusHelpDialog.help20_definition13'
                          | translate
                      }}
                    </div>

                    <div *ngSwitchDefault>N/A</div>
                  </ng-container>
                </ng-template>
              </ng-template>
            </div>

            <div
              style="font-style: italic; font-size: 0.85rem"
              class="cg-margin-top-sm"
            >
              <div data-test-id="last-updated-label">Last updated</div>
              <div data-test-id="last-updated-date">
                {{
                  adjustment.OvUpdated || adjustment.updateDate
                    | date : 'M/d/yyyy'
                }}
              </div>
            </div>
          </ng-template>
        </td>
        <td class="cg-datatable__cell" data-test-id="decision-notes-cell">
          <ng-container
            *ngIf="adjustment.isDowncodingAdjustment; else normalNotes"
          >
            <span>{{
              knownDowncodeStatuses.includes(adjustment.status)
                ? DecisionNotesMapping[adjustment.status]
                : "Your reconsideration is still moving through clinical review.
                No action is needed right now. We'll update this claim once a
                review outcome is available."
            }}</span>

            <ng-container *ngIf="downcodeDecisionLetter">
              <button
                data-test-id="button-decision-letter"
                cignaButton="link"
                style="padding-left: 0"
                (click)="openPdfEvent.emit(downcodeDecisionLetter)"
                [disabled]="isPdfLoading"
              >
                View decision letter
                <mat-icon
                  svgIcon="leaf-system-regular-pdf"
                  class="cg-icon-xs cg-margin-left-sm"
                  data-test-id="help-status-popup"
                ></mat-icon>
              </button>
            </ng-container>
          </ng-container>
          <ng-template #normalNotes>
            <ng-container
              *ngIf="
                adjustment.status !== 'REROUTED_TO_CORR' &&
                  adjustment.decisionNotes &&
                  !noNotesStatuses.includes(adjustment.status);
                else noNotes
              "
            >
              <button
                cignaButton="link"
                style="padding: 0; position: relative; bottom: 8px"
                (click)="openDecisionNotes(decisionNotesPopup)"
                data-test-id="decision-notes-popup"
                [cignaTrackClicks]="[
                  'trackEventOther',
                  'Decision Notes',
                  'ac-rec025'
                ]"
              >
                <span>Read Notes</span>
              </button>
            </ng-container>
          </ng-template>

          <ng-template #noNotes>
            <div>N/A</div>
          </ng-template>

          <ng-template #decisionNotesPopup>
            <div class="cg-dialog">
              <h3 class="cg-dialog__header cg-dialog__header--modal">
                {{
                  'shared.reconsiderationHistory.headers.decisionNotes'
                    | translate
                }}
                <button
                  cignaButton="link inline no-underline"
                  class="cg-dialog__close_new"
                  (click)="dialogRef.close()"
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Close',
                    'ac-rec003',
                    { prop20: 'Decision notes modal' }
                  ]"
                >
                  {{ 'shared.reconsiderationHistory.close' | translate }}
                  <cigna-icon
                    class="cml-close-icon"
                    type="close-thin"
                  ></cigna-icon>
                </button>
              </h3>

              <mat-dialog-content>
                <div class="cg-margin-bottom-xl">
                  <ng-container [ngSwitch]="adjustment.status.toLowerCase()">
                    <p *ngSwitchCase="adjustmentStatus.PENDED.toLowerCase()">
                      {{
                        'shared.reconsiderationHistory.decisionNotesStandardMsg'
                          | translate
                      }}
                    </p>
                    <p *ngSwitchDefault>{{ adjustment.decisionNotes }}</p>
                  </ng-container>
                </div>
              </mat-dialog-content>
            </div>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>

<ng-template #loading>
  <div class="loading">
    <div class="cg-spinner"></div>
  </div>
</ng-template>

<ng-template #error let-e>
  <div
    *ngIf="e?.code || e?.status"
    data-test-id="error-msg"
    class="cg-error-msg-large cg-margin-bottom-lg"
  >
    <cigna-icon type="exclamation-circle"></cigna-icon>
    <div data-spa-service-error>
      RECHSTR{{ e.code ? e.code : e.status }}:
      <span> {{ e.errObject.message }} </span>
    </div>
  </div>
</ng-template>

<ng-template #noAdjustments>
  <div class="no-history">
    {{
      (isPrecert
        ? 'shared.reconsiderationHistory.noAppeals'
        : 'shared.reconsiderationHistory.noAdjustmentData'
      ) | translate
    }}
  </div>
</ng-template>

<ng-template #removeConfirmationTemplate let-data>
  <div
    class="cg-dialog"
    aria-labelledby="header"
    data-test-id="delete-reconsideration-confirmation-modal"
  >
    <h3
      id="header"
      class="cg-dialog__header cg-dialog__header--modal dialog-header"
    >
      {{
        'shared.reconsiderationHistory.removeConfirmationDialog.header'
          | translate
      }}
    </h3>
    <p>
      {{
        'shared.reconsiderationHistory.removeConfirmationDialog.text'
          | translate
      }}
    </p>

    <div class="cg-button-group cg-margin-top-lg">
      <button
        cignaButton="primary"
        (click)="
          confirmRemoveAdjustment(data.id, data.reconType); dialogRef.close()
        "
        [cignaTrackClicks]="[
          'trackEventOther',
          'shared.reconsiderationHistory.removeConfirmationDialog.delete'
            | translate,
          'ac-rec031',
          { prop20: 'Delete Open Draft modal' }
        ]"
        data-test-id="confirm-delete-reconsideration"
      >
        {{
          'shared.reconsiderationHistory.removeConfirmationDialog.delete'
            | translate
        }}
      </button>
      <button
        cignaButton="link no-underline"
        (click)="dialogRef.close()"
        data-test-id="cancel-delete-reconsideration"
      >
        {{
          'shared.reconsiderationHistory.removeConfirmationDialog.cancel'
            | translate
        }}
      </button>
    </div>
  </div>
</ng-template>
